var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.233 169.659C434.593 72.932 353.671 0 256.011 0 151.677 0 66.798 84.878 66.798 189.212c0 41.238 12.957 80.324 37.489 113.062L242.163 504.63a16.698 16.698 0 0 0 13.847 7.369c5.554 0 10.738-2.76 13.847-7.369l137.496-201.855c28.576-37.944 41.672-85.225 36.88-133.116zm-188.222 103.03c-46.031 0-83.476-37.445-83.476-83.476s37.444-83.476 83.476-83.476c46.031 0 83.476 37.445 83.476 83.476s-37.445 83.476-83.476 83.476z"
  })));
};
export default SvgLocation;